import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Birthday(props: StickerArtProps) {
  return (
    <StickerFrame background="#f472b6" {...props}>
      <rect x="15" y="32" width="34" height="17" rx="3" fill="#ffffff" />
      <path
        d="M15 38 Q19.25 42 23.5 38 Q27.75 42 32 38 Q36.25 42 40.5 38 Q44.75 42 49 38"
        fill="none"
        stroke="#db2777"
        strokeWidth="3"
      />
      <rect x="30" y="20" width="4" height="12" rx="1" fill="#2563eb" />
      <path d="M32 11 C36 16 36 19 32 20 C28 19 28 16 32 11 Z" fill="#facc15" stroke="#1f2937" strokeWidth="1" />
    </StickerFrame>
  );
}
